import { set, keyBy } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import { fetchVisitColumns } from '../../../sagas/visit/routines';

const initialState = {
  all: {},
  fetching: false,
  fetchingError: null,
  updating: false,
  saving: false,
  saveError: null,
  updateError: null
};

export const fetchVisitColumnsHandler = routine => ({
  [routine.TRIGGER]: state => ({
    ...state,
    fetching: true,
    fetched: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set(`all`, keyBy('name', response.items), state),
  [routine.FAILURE]: (state, { error }) => set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

export default createReducer(initialState, {
  ...fetchVisitColumnsHandler(fetchVisitColumns)
});
